// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/task/v1/search.proto" (package "c1.api.task.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { TaskSearchService } from "./search";
import type { ListOpenExtensionTicketsResponse } from "./search";
import type { ListOpenExtensionTicketsRequest } from "./search";
import type { CountOpenExtensionTicketsResponse } from "./search";
import type { CountOpenExtensionTicketsRequest } from "./search";
import type { SearchCertifyTicketsByUserViewResponse } from "./search";
import type { SearchCertifyTicketsByUserViewRequest } from "./search";
import type { SearchCertifyTicketsByAppViewResponse } from "./search";
import type { SearchCertifyTicketsByAppViewRequest } from "./search";
import type { RollupEntitlementsWithTasksResponse } from "./search";
import type { RollupEntitlementsWithTasksRequest } from "./search";
import type { SearchWaitingOnResponse } from "./search";
import type { SearchWaitingOnRequest } from "./search";
import type { TaskSearchServiceSearchTasksByGrantsResponse } from "./search";
import type { TaskSearchServiceSearchTasksByGrantsRequest } from "./search";
import type { CountAuditEventTypeErrorResponse } from "./search";
import type { CountAuditEventTypeErrorRequest } from "./search";
import type { CountCompletedTicketsWithinMonthResponse } from "./search";
import type { CountCompletedTicketsWithinMonthRequest } from "./search";
import type { TaskSearchGetProgressResponse } from "./search";
import type { TaskSearchGetProgressRequest } from "./search";
import type { GetAllAppsForTaskSearchResponse } from "./search";
import type { GetAllAppsForTaskSearchRequest } from "./search";
import type { TaskSearchCountByTypeResponse } from "./search";
import type { TaskSearchCountByTypeRequest } from "./search";
import type { TaskSearchCountResponse } from "./search";
import type { TaskSearchCountRequest } from "./search";
import type { SearchTermsResponse } from "./search";
import type { TaskSearchTermsRequest } from "./search";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { TaskSearchResponse } from "./search";
import type { TaskSearchRequest } from "./search";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.task.v1.TaskSearchService
 */
export interface ITaskSearchServiceClient {
    /**
     * Search tasks based on filters specified in the request body.
     *
     * @generated from protobuf rpc: Search(c1.api.task.v1.TaskSearchRequest) returns (c1.api.task.v1.TaskSearchResponse);
     */
    search(input: TaskSearchRequest, options?: RpcOptions): UnaryCall<TaskSearchRequest, TaskSearchResponse>;
    /**
     * @generated from protobuf rpc: GetSearchTerms(c1.api.task.v1.TaskSearchTermsRequest) returns (c1.api.task.v1.SearchTermsResponse);
     */
    getSearchTerms(input: TaskSearchTermsRequest, options?: RpcOptions): UnaryCall<TaskSearchTermsRequest, SearchTermsResponse>;
    /**
     * @generated from protobuf rpc: SearchCount(c1.api.task.v1.TaskSearchCountRequest) returns (c1.api.task.v1.TaskSearchCountResponse);
     */
    searchCount(input: TaskSearchCountRequest, options?: RpcOptions): UnaryCall<TaskSearchCountRequest, TaskSearchCountResponse>;
    /**
     * @generated from protobuf rpc: SearchCountByType(c1.api.task.v1.TaskSearchCountByTypeRequest) returns (c1.api.task.v1.TaskSearchCountByTypeResponse);
     */
    searchCountByType(input: TaskSearchCountByTypeRequest, options?: RpcOptions): UnaryCall<TaskSearchCountByTypeRequest, TaskSearchCountByTypeResponse>;
    /**
     * @generated from protobuf rpc: GetAllAppsForTaskSearch(c1.api.task.v1.GetAllAppsForTaskSearchRequest) returns (c1.api.task.v1.GetAllAppsForTaskSearchResponse);
     */
    getAllAppsForTaskSearch(input: GetAllAppsForTaskSearchRequest, options?: RpcOptions): UnaryCall<GetAllAppsForTaskSearchRequest, GetAllAppsForTaskSearchResponse>;
    /**
     * @generated from protobuf rpc: GetProgress(c1.api.task.v1.TaskSearchGetProgressRequest) returns (c1.api.task.v1.TaskSearchGetProgressResponse);
     */
    getProgress(input: TaskSearchGetProgressRequest, options?: RpcOptions): UnaryCall<TaskSearchGetProgressRequest, TaskSearchGetProgressResponse>;
    /**
     * @generated from protobuf rpc: CountCompletedTicketsWithinMonth(c1.api.task.v1.CountCompletedTicketsWithinMonthRequest) returns (c1.api.task.v1.CountCompletedTicketsWithinMonthResponse);
     */
    countCompletedTicketsWithinMonth(input: CountCompletedTicketsWithinMonthRequest, options?: RpcOptions): UnaryCall<CountCompletedTicketsWithinMonthRequest, CountCompletedTicketsWithinMonthResponse>;
    /**
     * Given a task ID, return a count of how many audit events with the 'error' type exist in the audit log
     *
     * @generated from protobuf rpc: CountAuditEventTypeError(c1.api.task.v1.CountAuditEventTypeErrorRequest) returns (c1.api.task.v1.CountAuditEventTypeErrorResponse);
     */
    countAuditEventTypeError(input: CountAuditEventTypeErrorRequest, options?: RpcOptions): UnaryCall<CountAuditEventTypeErrorRequest, CountAuditEventTypeErrorResponse>;
    /**
     * Given a list of grants, return a list of open revocation tasks
     *
     * @generated from protobuf rpc: SearchTasksByGrants(c1.api.task.v1.TaskSearchServiceSearchTasksByGrantsRequest) returns (c1.api.task.v1.TaskSearchServiceSearchTasksByGrantsResponse);
     */
    searchTasksByGrants(input: TaskSearchServiceSearchTasksByGrantsRequest, options?: RpcOptions): UnaryCall<TaskSearchServiceSearchTasksByGrantsRequest, TaskSearchServiceSearchTasksByGrantsResponse>;
    /**
     * Given a task ID, return a list of tasks that it is waiting on
     *
     * @generated from protobuf rpc: SearchWaitingOn(c1.api.task.v1.SearchWaitingOnRequest) returns (c1.api.task.v1.SearchWaitingOnResponse);
     */
    searchWaitingOn(input: SearchWaitingOnRequest, options?: RpcOptions): UnaryCall<SearchWaitingOnRequest, SearchWaitingOnResponse>;
    /**
     * Given a list of entitlement IDs, and an AppUser ID or User ID, return a list of tasks that are associated with the them.
     *
     * @generated from protobuf rpc: RollupEntitlementsWithTasks(c1.api.task.v1.RollupEntitlementsWithTasksRequest) returns (c1.api.task.v1.RollupEntitlementsWithTasksResponse);
     */
    rollupEntitlementsWithTasks(input: RollupEntitlementsWithTasksRequest, options?: RpcOptions): UnaryCall<RollupEntitlementsWithTasksRequest, RollupEntitlementsWithTasksResponse>;
    /**
     * Search certify tasks by app view - returns tasks that the current user can see for a specific app
     *
     * @generated from protobuf rpc: SearchCertifyTicketsByAppView(c1.api.task.v1.SearchCertifyTicketsByAppViewRequest) returns (c1.api.task.v1.SearchCertifyTicketsByAppViewResponse);
     */
    searchCertifyTicketsByAppView(input: SearchCertifyTicketsByAppViewRequest, options?: RpcOptions): UnaryCall<SearchCertifyTicketsByAppViewRequest, SearchCertifyTicketsByAppViewResponse>;
    /**
     * Search certify tasks by user view - returns tasks that the current user can see for a specific identity user
     *
     * @generated from protobuf rpc: SearchCertifyTicketsByUserView(c1.api.task.v1.SearchCertifyTicketsByUserViewRequest) returns (c1.api.task.v1.SearchCertifyTicketsByUserViewResponse);
     */
    searchCertifyTicketsByUserView(input: SearchCertifyTicketsByUserViewRequest, options?: RpcOptions): UnaryCall<SearchCertifyTicketsByUserViewRequest, SearchCertifyTicketsByUserViewResponse>;
    /**
     * Count the number of open extension tickets.
     *
     * @generated from protobuf rpc: CountOpenExtensionTickets(c1.api.task.v1.CountOpenExtensionTicketsRequest) returns (c1.api.task.v1.CountOpenExtensionTicketsResponse);
     */
    countOpenExtensionTickets(input: CountOpenExtensionTicketsRequest, options?: RpcOptions): UnaryCall<CountOpenExtensionTicketsRequest, CountOpenExtensionTicketsResponse>;
    /**
     * List open extension tickets with their associated expiring bindings.
     *
     * @generated from protobuf rpc: ListOpenExtensionTickets(c1.api.task.v1.ListOpenExtensionTicketsRequest) returns (c1.api.task.v1.ListOpenExtensionTicketsResponse);
     */
    listOpenExtensionTickets(input: ListOpenExtensionTicketsRequest, options?: RpcOptions): UnaryCall<ListOpenExtensionTicketsRequest, ListOpenExtensionTicketsResponse>;
}
/**
 * @generated from protobuf service c1.api.task.v1.TaskSearchService
 */
export class TaskSearchServiceClient implements ITaskSearchServiceClient, ServiceInfo {
    typeName = TaskSearchService.typeName;
    methods = TaskSearchService.methods;
    options = TaskSearchService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Search tasks based on filters specified in the request body.
     *
     * @generated from protobuf rpc: Search(c1.api.task.v1.TaskSearchRequest) returns (c1.api.task.v1.TaskSearchResponse);
     */
    search(input: TaskSearchRequest, options?: RpcOptions): UnaryCall<TaskSearchRequest, TaskSearchResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskSearchRequest, TaskSearchResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetSearchTerms(c1.api.task.v1.TaskSearchTermsRequest) returns (c1.api.task.v1.SearchTermsResponse);
     */
    getSearchTerms(input: TaskSearchTermsRequest, options?: RpcOptions): UnaryCall<TaskSearchTermsRequest, SearchTermsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskSearchTermsRequest, SearchTermsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchCount(c1.api.task.v1.TaskSearchCountRequest) returns (c1.api.task.v1.TaskSearchCountResponse);
     */
    searchCount(input: TaskSearchCountRequest, options?: RpcOptions): UnaryCall<TaskSearchCountRequest, TaskSearchCountResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskSearchCountRequest, TaskSearchCountResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchCountByType(c1.api.task.v1.TaskSearchCountByTypeRequest) returns (c1.api.task.v1.TaskSearchCountByTypeResponse);
     */
    searchCountByType(input: TaskSearchCountByTypeRequest, options?: RpcOptions): UnaryCall<TaskSearchCountByTypeRequest, TaskSearchCountByTypeResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskSearchCountByTypeRequest, TaskSearchCountByTypeResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetAllAppsForTaskSearch(c1.api.task.v1.GetAllAppsForTaskSearchRequest) returns (c1.api.task.v1.GetAllAppsForTaskSearchResponse);
     */
    getAllAppsForTaskSearch(input: GetAllAppsForTaskSearchRequest, options?: RpcOptions): UnaryCall<GetAllAppsForTaskSearchRequest, GetAllAppsForTaskSearchResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAllAppsForTaskSearchRequest, GetAllAppsForTaskSearchResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetProgress(c1.api.task.v1.TaskSearchGetProgressRequest) returns (c1.api.task.v1.TaskSearchGetProgressResponse);
     */
    getProgress(input: TaskSearchGetProgressRequest, options?: RpcOptions): UnaryCall<TaskSearchGetProgressRequest, TaskSearchGetProgressResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskSearchGetProgressRequest, TaskSearchGetProgressResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CountCompletedTicketsWithinMonth(c1.api.task.v1.CountCompletedTicketsWithinMonthRequest) returns (c1.api.task.v1.CountCompletedTicketsWithinMonthResponse);
     */
    countCompletedTicketsWithinMonth(input: CountCompletedTicketsWithinMonthRequest, options?: RpcOptions): UnaryCall<CountCompletedTicketsWithinMonthRequest, CountCompletedTicketsWithinMonthResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<CountCompletedTicketsWithinMonthRequest, CountCompletedTicketsWithinMonthResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Given a task ID, return a count of how many audit events with the 'error' type exist in the audit log
     *
     * @generated from protobuf rpc: CountAuditEventTypeError(c1.api.task.v1.CountAuditEventTypeErrorRequest) returns (c1.api.task.v1.CountAuditEventTypeErrorResponse);
     */
    countAuditEventTypeError(input: CountAuditEventTypeErrorRequest, options?: RpcOptions): UnaryCall<CountAuditEventTypeErrorRequest, CountAuditEventTypeErrorResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<CountAuditEventTypeErrorRequest, CountAuditEventTypeErrorResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Given a list of grants, return a list of open revocation tasks
     *
     * @generated from protobuf rpc: SearchTasksByGrants(c1.api.task.v1.TaskSearchServiceSearchTasksByGrantsRequest) returns (c1.api.task.v1.TaskSearchServiceSearchTasksByGrantsResponse);
     */
    searchTasksByGrants(input: TaskSearchServiceSearchTasksByGrantsRequest, options?: RpcOptions): UnaryCall<TaskSearchServiceSearchTasksByGrantsRequest, TaskSearchServiceSearchTasksByGrantsResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskSearchServiceSearchTasksByGrantsRequest, TaskSearchServiceSearchTasksByGrantsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Given a task ID, return a list of tasks that it is waiting on
     *
     * @generated from protobuf rpc: SearchWaitingOn(c1.api.task.v1.SearchWaitingOnRequest) returns (c1.api.task.v1.SearchWaitingOnResponse);
     */
    searchWaitingOn(input: SearchWaitingOnRequest, options?: RpcOptions): UnaryCall<SearchWaitingOnRequest, SearchWaitingOnResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchWaitingOnRequest, SearchWaitingOnResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Given a list of entitlement IDs, and an AppUser ID or User ID, return a list of tasks that are associated with the them.
     *
     * @generated from protobuf rpc: RollupEntitlementsWithTasks(c1.api.task.v1.RollupEntitlementsWithTasksRequest) returns (c1.api.task.v1.RollupEntitlementsWithTasksResponse);
     */
    rollupEntitlementsWithTasks(input: RollupEntitlementsWithTasksRequest, options?: RpcOptions): UnaryCall<RollupEntitlementsWithTasksRequest, RollupEntitlementsWithTasksResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<RollupEntitlementsWithTasksRequest, RollupEntitlementsWithTasksResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Search certify tasks by app view - returns tasks that the current user can see for a specific app
     *
     * @generated from protobuf rpc: SearchCertifyTicketsByAppView(c1.api.task.v1.SearchCertifyTicketsByAppViewRequest) returns (c1.api.task.v1.SearchCertifyTicketsByAppViewResponse);
     */
    searchCertifyTicketsByAppView(input: SearchCertifyTicketsByAppViewRequest, options?: RpcOptions): UnaryCall<SearchCertifyTicketsByAppViewRequest, SearchCertifyTicketsByAppViewResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchCertifyTicketsByAppViewRequest, SearchCertifyTicketsByAppViewResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Search certify tasks by user view - returns tasks that the current user can see for a specific identity user
     *
     * @generated from protobuf rpc: SearchCertifyTicketsByUserView(c1.api.task.v1.SearchCertifyTicketsByUserViewRequest) returns (c1.api.task.v1.SearchCertifyTicketsByUserViewResponse);
     */
    searchCertifyTicketsByUserView(input: SearchCertifyTicketsByUserViewRequest, options?: RpcOptions): UnaryCall<SearchCertifyTicketsByUserViewRequest, SearchCertifyTicketsByUserViewResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchCertifyTicketsByUserViewRequest, SearchCertifyTicketsByUserViewResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Count the number of open extension tickets.
     *
     * @generated from protobuf rpc: CountOpenExtensionTickets(c1.api.task.v1.CountOpenExtensionTicketsRequest) returns (c1.api.task.v1.CountOpenExtensionTicketsResponse);
     */
    countOpenExtensionTickets(input: CountOpenExtensionTicketsRequest, options?: RpcOptions): UnaryCall<CountOpenExtensionTicketsRequest, CountOpenExtensionTicketsResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<CountOpenExtensionTicketsRequest, CountOpenExtensionTicketsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List open extension tickets with their associated expiring bindings.
     *
     * @generated from protobuf rpc: ListOpenExtensionTickets(c1.api.task.v1.ListOpenExtensionTicketsRequest) returns (c1.api.task.v1.ListOpenExtensionTicketsResponse);
     */
    listOpenExtensionTickets(input: ListOpenExtensionTicketsRequest, options?: RpcOptions): UnaryCall<ListOpenExtensionTicketsRequest, ListOpenExtensionTicketsResponse> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListOpenExtensionTicketsRequest, ListOpenExtensionTicketsResponse>("unary", this._transport, method, opt, input);
    }
}
